import { render, staticRenderFns } from "./PayrollGroupEditor.vue?vue&type=template&id=171b6513"
import script from "./PayrollGroupEditor.vue?vue&type=script&lang=js"
export * from "./PayrollGroupEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports